import {
  CredentialHeading,
  CredentialHeadings,
  CredentialSubHeading,
  SourceCredentialContainer,
} from 'components/credits/credit-items/SourceCredentialSection/components';

import AndContainer from 'components/common/AndContainer';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import HeartIconContainer from 'components/common/HeartIconContainer';
import { RequiredCredential } from 'types/required-credential';
import { Spin } from 'antd';
import { getHeadingAndSubHeading } from 'utils/required-credential';
import useCreditBookmarks from 'hooks/use-credit-bookmarks';
import useFormSchema from 'hooks/use-form-schema';
import useIsMobile from 'hooks/use-is-mobile';
import useMetadata from 'hooks/use-metadata';

type Props = {
  requiredCredentials: RequiredCredential[];
  creditItemID: string;
  creditType: CreditType;
};

export default function SourceCredentialSection(props: Props): JSX.Element {
  const { creditItemID, creditType, requiredCredentials } = props;
  const isMobile = useIsMobile();
  const formSchema = useFormSchema();
  const metadata = useMetadata();
  const { creditBookmarks, addCreditBookmark, removeCreditBookmark } = useCreditBookmarks();

  if (!metadata || !formSchema) {
    return <Spin />;
  }

  const existsInBookmarks = creditBookmarks.has(creditItemID);

  const onBookmarkClick = () => {
    if (existsInBookmarks) {
      removeCreditBookmark(creditItemID);
      return;
    }
    addCreditBookmark({ creditItemID, creditType, timestamp: metadata.timestamp });
  };

  if (isMobile) {
    return (
      <FlexContainer flexDirection='row' justifyContent='space-between'>
        <SourceCredentialContainer className='source-credentials-list' aria-hidden='true'>
          {requiredCredentials.map((credential, index, array) => {
            const { heading, unjoinedHeadings, unjoinedSubHeadings } = getHeadingAndSubHeading(credential, formSchema);
            return (
              <CredentialHeadings key={heading}>
                <CredentialHeading className='source-credential-heading'>
                  {unjoinedHeadings.map((heading) => (
                    <span key={heading.propertyName} className={heading.propertyName}>
                      {heading.value + ' '}
                    </span>
                  ))}
                </CredentialHeading>
                <CredentialSubHeading className='source-credential-subheading'>
                  {unjoinedSubHeadings.map((subheading) => (
                    <span key={subheading.propertyName} className={subheading.propertyName}>
                      {subheading.value + ' '}
                    </span>
                  ))}
                </CredentialSubHeading>
                {index !== array.length - 1 && <AndContainer />}
              </CredentialHeadings>
            );
          })}
        </SourceCredentialContainer>
        <HeartIconContainer selected={existsInBookmarks} onSelect={onBookmarkClick} />
      </FlexContainer>
    );
  }

  return (
    <SourceCredentialContainer className='source-credentials-list' aria-hidden='true'>
      {requiredCredentials.map((credential, index, array) => {
        const { heading, unjoinedHeadings, unjoinedSubHeadings } = getHeadingAndSubHeading(credential, formSchema);
        return (
          <CredentialHeadings key={heading}>
            <CredentialHeading className='source-credential-heading'>
              {unjoinedHeadings.map((heading) => (
                <span key={heading.propertyName} className={heading.propertyName}>
                  {heading.value + ' '}
                </span>
              ))}
            </CredentialHeading>
            <CredentialSubHeading className='source-credential-subheading'>
              {unjoinedSubHeadings.map((subheading) => (
                <span key={subheading.propertyName} className={subheading.propertyName}>
                  {subheading.value + ' '}
                </span>
              ))}
            </CredentialSubHeading>
            {index !== array.length - 1 && <AndContainer />}
          </CredentialHeadings>
        );
      })}
    </SourceCredentialContainer>
  );
}
